class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    this.header = document.querySelector(".header-wrapper");
    this.desktopMediaQuery = window.matchMedia("(min-width: 990px)");
    this.closeTimer = null;

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);

    this.mainDetailsToggle.addEventListener("mouseenter", this.onMouseEnter);

    this.mainDetailsToggle.addEventListener("mouseleave", this.onMouseLeave);

    this.mainDetailsToggle.addEventListener("focusin", this.onFocusIn);

    if (this.desktopMediaQuery.addEventListener) {
      this.desktopMediaQuery.addEventListener(
        "change",
        this.onBreakpointChange,
      );
    } else {
      this.desktopMediaQuery.addListener(this.onBreakpointChange);
    }
  }

  disconnectedCallback() {
    clearTimeout(this.closeTimer);

    this.mainDetailsToggle.removeEventListener("mouseenter", this.onMouseEnter);

    this.mainDetailsToggle.removeEventListener("mouseleave", this.onMouseLeave);

    this.mainDetailsToggle.removeEventListener("focusin", this.onFocusIn);

    if (this.desktopMediaQuery.removeEventListener) {
      this.desktopMediaQuery.removeEventListener(
        "change",
        this.onBreakpointChange,
      );
    } else {
      this.desktopMediaQuery.removeListener(this.onBreakpointChange);
    }
  }

  onMouseEnter() {
    if (!this.desktopMediaQuery.matches) return;

    clearTimeout(this.closeTimer);
    this.openMenu();
  }

  onMouseLeave() {
    if (!this.desktopMediaQuery.matches) return;

    clearTimeout(this.closeTimer);

    this.closeTimer = setTimeout(() => {
      const pointerStillInside = this.mainDetailsToggle.matches(":hover");

      const focusStillInside = this.mainDetailsToggle.contains(
        document.activeElement,
      );

      if (!pointerStillInside && !focusStillInside) {
        this.close();
      }
    }, 180);
  }

  onFocusIn() {
    if (!this.desktopMediaQuery.matches) return;

    clearTimeout(this.closeTimer);
    this.openMenu();
  }

  openMenu() {
    /*
     * Close any other open desktop menu first.
     */
    document.querySelectorAll("header-menu").forEach((menu) => {
      if (menu !== this && typeof menu.close === "function") {
        menu.close();
      }
    });

    this.mainDetailsToggle.setAttribute("open", "");

    const summary = this.mainDetailsToggle.querySelector(":scope > summary");

    summary?.setAttribute("aria-expanded", "true");
  }

  onBreakpointChange(event) {
    clearTimeout(this.closeTimer);

    /*
     * Remove desktop hover state when switching
     * to tablet or mobile.
     */
    if (!event.matches) {
      this.close();
    }
  }

  onToggle() {
    /*
     * Keep the theme's original animation behaviour.
     */
    super.onToggle();

    if (!this.header) return;

    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    ) {
      return;
    }

    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define("header-menu", HeaderMenu);
